import React from 'react'
import styled, { css } from 'styled-components'

export type CompactActionTone = 'light' | 'dark'

const compactActionButtonStyles = css<{ $tone: CompactActionTone; $variant: 'default' | 'remove' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ theme }) => theme.iconSize.xxs}rem;
  height: ${({ theme }) => theme.iconSize.xxs}rem;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: transparent;
  color: ${({ theme, $tone }) =>
    $tone === 'dark' ? theme.colors.iconGray : theme.colors.metalGray};
  opacity: 0.35;
  cursor: pointer;
  transition: color 140ms ease-out, opacity 140ms ease-out;

  svg {
    width: ${({ theme }) => theme.iconSize.xxs}rem;
    height: ${({ theme }) => theme.iconSize.xxs}rem;
  }

  &:hover {
    background: transparent;
    opacity: 1;
    color: ${({ theme, $variant, $tone }) =>
      $variant === 'remove'
        ? theme.colors.error
        : $tone === 'dark'
        ? theme.colors.neutralWhite
        : theme.colors.iconGray};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.iconGray};
    outline-offset: 2px;
    opacity: 1;
    color: ${({ theme, $variant }) =>
      $variant === 'remove' ? theme.colors.error : theme.colors.iconGray};
  }
`

export const CompactActionSlot = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ theme }) => theme.iconSize.xxs}rem;
  height: ${({ theme }) => theme.iconSize.xxs}rem;
`

const StyledCompactActionButton = styled.button<{
  $tone: CompactActionTone
  $variant: 'default' | 'remove'
}>`
  ${compactActionButtonStyles}
`

export type CompactActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  tone?: CompactActionTone
  variant?: 'default' | 'remove'
}

export const CompactActionButton: React.FC<CompactActionButtonProps> = ({
  tone = 'light',
  variant = 'default',
  type = 'button',
  children,
  ...props
}) => (
  <StyledCompactActionButton type={type} $tone={tone} $variant={variant} {...props}>
    {children}
  </StyledCompactActionButton>
)
